import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { AdminGuard, SupplierGuard } from "../../guards/RolesGuard";
import { classNames } from "../../utils/classNames";
import { useGetCurrentUserQuery } from "../../store/user/userApi";

let navigationAgents = [
  {
    name: "Accountant",
    href: "/insights",
    icon: <img alt="accountant" src="/assets/navigation/agents/accountant.svg" />,
    iconActive: (
      <img alt="accountant" src="/assets/navigation/agents/accountant-active.svg" />
    ),
    enabled: true,
  },
  {
    name: "Purchasing Manager",
    href: "/purchase-orders",
    icon: <img alt="purchasing-manager" src="/assets/navigation/agents/purchasing-manager.svg" />,
    iconActive: (
      <img alt="purchasing-manager" src="/assets/navigation/agents/purchasing-manager-active.svg" />
    ),
    enabled: true,
  },
  {
    name: "Reservation Manager",
    href: "/reservations",
    icon: (
      <img alt="reservation-manager" src="/assets/navigation/agents/reservation-manager.svg" />
    ),
    iconActive: (
      <img alt="reservation-manager" src="/assets/navigation/agents/reservation-manager-active.svg" />
    ),
    enabled: true,
  },
  {
    name: "Receptionist",
    href: "receptionist",
    icon: (
      <img alt="receptionist" src="/assets/navigation/agents/receptionist.svg" />
    ),
    iconActive: (
      <img alt="receptionist" src="/assets/navigation/agents/receptionist-active.svg" />
    ),
    enabled: true,
    children: [
      {
        name: "Rooms Requests",
        href: "/room-request",
        enabled: true,
      },
      {
        name: "Drafts",
        href: "/drafts",
        enabled: true,
      },
      {
        name: "Calls",
        href: "/calls",
        enabled: true,
      },
    ],
  },

  {
    name: "Guest Intelligence",
    href: "/guest-intelligence",
    icon: (
      <img alt="guest-intelligence" src="/assets/navigation/agents/guest-intelligence.svg" />
    ),
    iconActive: (
      <img alt="guest-intelligence" src="/assets/navigation/agents/guest-intelligence-active.svg" />
    ),
    enabled: true,
  },
  {
    name: "Guest Intelligence 2",
    href: "/guest-intelligence-2",
    icon: (
      <img alt="guest-intelligence" src="/assets/navigation/agents/guest-intelligence.svg" />
    ),
    iconActive: (
      <img alt="guest-intelligence" src="/assets/navigation/agents/guest-intelligence-active.svg" />
    ),
    enabled: true,
  },
  {
    name: "Profile",
    href: "profile",
    icon: <img alt="profile" src="/assets/navigation/agents/profile.svg" />,
    iconActive: (
      <img alt="profile" src="/assets/navigation/agents/profile-active.svg" />
    ),
    enabled: true,
	  children: [
		{
			name: "Users",
			href: "/users",
			icon: <img alt="profile" src="/assets/navigation/agents/profile.svg" />,
			iconActive: (
			  <img alt="profile" src="/assets/navigation/agents/profile-active.svg" />
			),
			enabled: true,
		  },
		  {
			name: "Suppliers",
			href: "/suppliers",
			icon: <img alt="suppliers" src="/assets/navigation/agents/profile.svg" />,
			iconActive: (
			  <img alt="suppliers" src="/assets/navigation/agents/profile-active.svg" />
			),
			enabled: true,
		  },
	  ]
  },
  {
    name: "AI Logs",
    href: "/ai-logs",
    icon: (
      <img
        alt="ai-reservations"
        src="/assets/navigation/ai-reservations.svg"
      />
    ),
    iconActive: (
      <img alt="guest-intelligence" src="/assets/navigation/agents/guest-intelligence-active.svg" />
    ),
    enabled: true,
    access: "partners",
  },
  {
    name: "Customer Experience Assistant",
    href: "/customer-experience-assistant",
    icon: (
      <img
        alt="customer-experience-assistant"
        src="/assets/navigation/agents/customer-experience-assistant.svg"
      />
    ),
    iconActive: (
      <img alt="accountant" src="/assets/navigation/agents/customer-experience-assistant-active.svg" />
    ),
    enabled: true,
  },
  {
    name: "Settings",
    href: "/settings",
    icon: <img alt="settings" src="/assets/navigation/ai-reservations.svg" />,
    iconActive: (
      <img alt="accountant" src="/assets/navigation/agents/guest-intelligence-active.svg" />
    ),
    enabled: true,
  },
];

const navigationSupplier = [
  {
    name: "Invoices",
    href: "/invoices",
    icon: <img alt="invoices" src="/assets/navigation/invoices.svg" />,
    iconActive: (
      <img alt="accountant" src="/assets/navigation/accountant-active.svg" />
    ),
    enabled: true,
  },
];

const navigationAdmin = [
  {
    name: "Users",
    href: "/users",
    icon: <img alt="users" src="/assets/navigation/partners.svg" />,
    iconActive: (
      <img alt="accountant" src="/assets/navigation/accountant-active.svg" />
    ),
    enabled: true,
  },
];

const Navigation = () => {
  const [collapsed, setCollapsed] = useState<{[key: string]: boolean}>()
  const isAdmin = AdminGuard();
  const isSupplier = SupplierGuard();
  const { data: user } = useGetCurrentUserQuery();
  const userRole = user?.groups?.[0] || localStorage.getItem("roles") || "";

  const handleCollapse = (id: string) => {
    console.log("collapse: ", id);
	const updated = collapsed?.[id] ? {[id]: false} : {[id]: true};
	setCollapsed(
		{
		...collapsed,
		...updated
		}
	)
  };

  //   const checkActive = (path: string) => location.pathname.startsWith(path)

  navigationAgents = [
    "mrchow",
    "casadino",
    "beautysalon",
    "salesagent",
  ].includes(user?.username || "")
    ? navigationAgents.filter((nav) => nav.name.toLowerCase() === "calls")
    : navigationAgents;
  return (
    <>
      {isAdmin ? (
        <>
          {navigationAdmin.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                classNames(
                  "text-base text-primary-default group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-primary",
                  item.enabled && isActive ? "font-bold" : "font-normal"
                )
              }
            >
              {/* <img alt="dashboard" src={checkActive(item.href) ? "/assets/navigation/dashboard-active.svg" : "/assets/navigation/dashboard.svg"} />, */}
              {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
              {item.icon ? (
                <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                  {React.cloneElement(item.icon, { width: 20, height: 20 })}
                </span>
              ) : (
                <span className="flex w-8" />
              )}
              {item.name}
            </NavLink>
          ))}
        </>
      ) : (
        <>
          {isSupplier ? (
            <>
              {navigationSupplier.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    classNames(
                      "text-base  group flex items-center px-2 py-2 font-medium rounded-md mb-2 font-primary",
                      item.enabled && isActive
                        ? "bg-call-default text-saloon-btn"
                        : "text-secondary"
                    )
                  }
                >
                  {/* <item.icon className="mr-3 flex-shrink-0 h-6 w-6 text-indigo-300" aria-hidden="true" /> */}
                  <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                    {React.cloneElement(item.icon, { width: 20, height: 20 })}
                  </span>
                  {item.name}
                </NavLink>
              ))}
            </>
          ) : (
            <>
              {navigationAgents
                .filter(
                  (item: any) => !item?.access || item.access === userRole
                )
                ?.map((item) => (
                  <>
                    {item.children ? (
                      <button
                        key={item.name}
                        onClick={() => handleCollapse(item.href)}
                        className={classNames(
                          "w-full text-sm group flex items-center px-2 py-2 font-normal rounded-md my-1.5 font-primary text-primary-default"
                        )}
                      >
                        {item.icon ? (
                          <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                            {React.cloneElement(item.icon, {
                              width: 24,
                              height: 24,
                            })}
                          </span>
                        ) : (
                          <span className="flex w-8" />
                        )}
                        {item.name}

						<img 
						alt='arrow down'
						className={classNames("ml-auto transition-transform", collapsed?.[item.href] ? 'rotate-180' : '')}
						src='/assets/navigation/arrow-down.svg' />
                      </button>
                    ) : (
                      <NavLink
                        key={item.name}
                        to={item.href}
                        className={({ isActive }) =>
                          classNames(
                            "text-sm group flex items-center px-2 py-2 font-normal rounded-md my-1.5 font-primary",
                            item.enabled && isActive
                              ? "bg-[#00330F14] bg-opacity-10 text-saloon-btn"
                              : "text-primary-default"
                          )
                        }
                      >
                        {({ isActive }) => (
                          <>
                            {item.icon ? (
                              <span className="flex mr-2 flex-shrink-0 h-6 w-6 justify-center items-center">
                                {React.cloneElement(
                                  isActive ? item.iconActive : item.icon,
                                  {
                                    width: 24,
                                    height: 24,
                                  }
                                )}
                              </span>
                            ) : (
                              <span className="flex w-8" />
                            )}
                            {item.name}  
                          </> 
                        )}
                      </NavLink>
                    )}

                    <div className={classNames("pl-8 w-full flex flex-col", collapsed?.[item.href] ? 'h-0 overflow-hidden' : '')}>
                      {item.children?.map((item) => (
                        <NavLink
                          key={item.name}
                          className={({ isActive }) =>
                            classNames(
                              "w-full text-sm font-normal p-2 text-primary-default rounded-md",
                              item.enabled && isActive
                                ? "bg-[#00330F14] bg-opacity-10 text-saloon-btn"
                                : "text-primary-default"
                            )
                          }
                          to={item.href}
                        >
                          {item.name}
                        </NavLink>
                      ))}
                    </div>
                  </>
                ))}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Navigation;